import { Checkbox, Flex, Spinner, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useProlongationsStore } from '../../store/prolongationsStore'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import ProlongationService from '../../API/ProlongationService'
import { toastError } from '../../utils/globalHelper'

function MailingCheckbox({prolongation}) {
    const toast = useToast()
    const updateProlongation = useProlongationsStore(state => state.updateProlongation)
    const updateCheckbox = useAccessAPI(ProlongationService.checkedPurchaseMailing)
    const [isLoading, setIsLoading] = useState(false)

    const onChange = async (e) => {
        setIsLoading(true)
        const is_checked = e.target.checked
        const response = await updateCheckbox(prolongation.prolongation_id, is_checked)
        if (response?.status === 200) {
            updateProlongation({...prolongation, checkbox: is_checked})
        }
        else {
            toast(toastError(
                'Не удалось активировать отписки',
                typeof response?.data?.detail === 'string' && response?.data?.detail
            ))
        }
        setIsLoading(false)
    }

    return (
        <Flex alignItems='center' justifyContent='center'>
        {
            isLoading
            ?
            <Spinner size='sm' />
            :
            <Checkbox
                isChecked={prolongation?.checkbox}
                onChange={onChange}
                colorScheme='orange'
            />
        }
        </Flex>
    )
}

export default MailingCheckbox
